export default (state, action) => {
  return Object.assign({}, state, { search: action.search });
};
